import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Wrapper, Line, StyledText } from './spacer.style.js';

const Spacer = ({ className = '', innerText = '', padding = '40px 0', }) => {
    return (jsxs(Wrapper, Object.assign({ className: className, padding: padding }, { children: [jsx(Line, {}, void 0), innerText && (jsxs(Fragment, { children: [jsx(StyledText, Object.assign({ textStyle: "paragraph400", color: "secondary" }, { children: innerText }), void 0), jsx(Line, {}, void 0)] }, void 0))] }), void 0));
};

export { Spacer };
